import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import _imports_0 from '@/img/icon/minus.svg';
import _imports_1 from '@/img/icon/plus.svg';
const _hoisted_1 = {
  class: "basket__item"
};
const _hoisted_2 = {
  class: "basket__left"
};
const _hoisted_3 = {
  class: "basket__imgwrapper"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "basket__box"
};
const _hoisted_6 = {
  class: "basket__item-title"
};
const _hoisted_7 = {
  class: "basket__weight"
};
const _hoisted_8 = {
  class: "basket__right"
};
const _hoisted_9 = {
  class: "basket__price"
};
const _hoisted_10 = {
  class: "basket__btns"
};
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "minus"
}, null, -1);
const _hoisted_12 = [_hoisted_11];
const _hoisted_13 = {
  class: "basket-count"
};
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "plus"
}, null, -1);
const _hoisted_15 = [_hoisted_14];
const _hoisted_16 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "17",
  height: "17",
  viewBox: "0 0 17 17",
  fill: "none"
}, [/*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M13.2547 4.2431C13.5172 4.50555 13.5172 4.93106 13.2547 5.19351L5.19022 13.258C4.92777 13.5205 4.50225 13.5205 4.23981 13.258C3.97736 12.9956 3.97736 12.5701 4.23981 12.3076L12.3043 4.2431C12.5668 3.98065 12.9923 3.98065 13.2547 4.2431Z",
  fill: "white"
}), /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M4.23981 4.2431C4.50225 3.98065 4.92777 3.98065 5.19022 4.2431L13.2547 12.3076C13.5172 12.5701 13.5172 12.9956 13.2547 13.258C12.9923 13.5205 12.5668 13.5205 12.3043 13.258L4.23981 5.19351C3.97736 4.93106 3.97736 4.50555 4.23981 4.2431Z",
  fill: "white"
})], -1);
const _hoisted_17 = [_hoisted_16];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");
  return _openBlock(), _createBlock(_component_router_link, {
    to: `/rol-shop/${$props.category}/${$props.id}`
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
      class: "basket__img",
      src: require(`@/img/products/${$props.filename}`),
      alt: "product"
    }, null, 8, _hoisted_4)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("p", _hoisted_6, _toDisplayString($props.title), 1), _createElementVNode("p", _hoisted_7, "Вес: " + _toDisplayString($props.weight) + " г", 1)])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("p", _hoisted_9, _toDisplayString($props.price) + " грн", 1), _createElementVNode("div", _hoisted_10, [_createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('onClickMinus')),
      class: "basket__btn"
    }, _hoisted_12), _createElementVNode("p", _hoisted_13, _toDisplayString($props.count), 1), _createElementVNode("button", {
      onClick: _cache[1] || (_cache[1] = $event => _ctx.$emit('onClickPlus')),
      class: "basket__btn"
    }, _hoisted_15)])]), _createElementVNode("button", {
      class: "basket-remove",
      onClick: _cache[2] || (_cache[2] = $event => _ctx.$emit('onClickRemove'))
    }, _hoisted_17)])]),
    _: 1
  }, 8, ["to"]);
}